// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoResults-root-sd_Ow {
    margin: 60px 20px 0;
    text-align: center;
}

.NoResults-noHeading-wA8hu {
    font-size: 20px;
    margin-top: 20px;
}

.NoResults-noSubHeading-VBu6Z {
    font-size: 18px;
    margin: 10px 0 0;
    color: var(--secondary-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/NoResults/NoResults.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;AACtC","sourcesContent":[".root {\n    margin: 60px 20px 0;\n    text-align: center;\n}\n\n.noHeading {\n    font-size: 20px;\n    margin-top: 20px;\n}\n\n.noSubHeading {\n    font-size: 18px;\n    margin: 10px 0 0;\n    color: var(--secondary-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NoResults-root-sd_Ow`,
	"noHeading": `NoResults-noHeading-wA8hu`,
	"noSubHeading": `NoResults-noSubHeading-VBu6Z`
};
module.exports = ___CSS_LOADER_EXPORT___;
